/** GENERATED_ASSET — brass spout: boss plate, nozzle and flared mouth. Tarnish varies by variant. */
import type { Ctx } from './ctx';
import type { Layer } from './svgKit';
import { Path, arcPoints } from './pathKit';
import { CX } from './layout';

export function spoutMouth(ctx: Ctx): { x: number; y: number } {
  return { x: CX, y: ctx.L.stele.mouthY + 0.5 };
}

export function paintSpout(ctx: Ctx, L: Layer): void {
  const { sw, L: lay, v } = ctx;
  const { plateY, mouthY } = lay.stele;
  const b = sw.brass;
  // Boss plate.
  L.circle(CX, plateY, 12, { fill: b.base, stroke: b.rim, sw: 1.9, part: 'brass-plate' });
  L.circle(CX, plateY, 8, { fill: 'none', stroke: b.dark, sw: 1, so: 0.8, part: 'brass-ring' });
  L.path(new Path().poly(arcPoints(CX, plateY, 9.6, 9.6, 200, 275, 10), false), { stroke: b.light, sw: 1.7, so: 0.95, part: 'brass-gleam' });
  if (ctx.detail.minorRepairs) {
    for (const [dx, dy] of [[-8.6, -8.6], [8.6, -8.6], [-8.6, 8.6], [8.6, 8.6]] as const) {
      L.circle(CX + dx * 0.78, plateY + dy * 0.78, 1.15, { fill: b.dark, part: 'brass-rivet' });
    }
  }
  // Nozzle tube, then flared mouth with a dark opening.
  L.path(new Path().poly([{ x: CX - 6.5, y: plateY + 8 }, { x: CX + 6.5, y: plateY + 8 }, { x: CX + 5.4, y: mouthY - 3 }, { x: CX - 5.4, y: mouthY - 3 }]),
    { fill: b.base, stroke: b.rim, sw: 1.7, part: 'brass-nozzle' });
  L.line(CX - 3.2, plateY + 10, CX - 3, mouthY - 5, { stroke: b.light, sw: 1.5, so: 0.9, part: 'brass-gleam' });
  L.ellipse(CX, mouthY, 9, 4.2, { fill: b.base, stroke: b.rim, sw: 1.7, part: 'brass-mouth' });
  L.ellipse(CX, mouthY + 0.4, 5.6, 2.3, { fill: ctx.sw.outline, part: 'brass-opening' });
  if (v.brassTarnish > 0) {
    const n = Math.round(v.brassTarnish * 5);
    const r = ctx.rng('brass.tarnish');
    for (let i = 0; i < 5; i++) {
      const a = r.range(0, Math.PI * 2), d = r.range(2, 8.5), rx = r.range(1.5, 3.4), ry = r.range(1, 2.4);
      if (i >= n) continue;
      L.ellipse(CX + Math.cos(a) * d, plateY + Math.abs(Math.sin(a)) * d * 0.8 + 1, rx, ry, { fill: b.tarnish, fo: 0.4 + v.brassTarnish * 0.45, part: 'brass-tarnish' });
    }
    if (v.brassTarnish > 0.3) L.ellipse(CX, mouthY - 6.5, 4.4, 2.2, { fill: b.tarnish, fo: v.brassTarnish * 0.7, part: 'brass-tarnish' });
  }
}
